import { createContext } from 'react';
import { IItemForGetShortInfo, TFileId, ICreateTeaser, TTeaserContentTypes, TTeaserControlPoints } from 'types';

export type TCreateTeaserVisibleForm = 'mainForm' | 'translations';
export type TSourceUrlLocally = Nullable<string>;
export type TCreateTeaserSelectedItem = string | null;
export type TCreateTeaserSelectedContentType = TTeaserContentTypes | null;
export type TCreateTeaserTransitionType = 'dish' | 'game' | null;
export type TCreateTeaserControlPoint = TTeaserControlPoints | null;
export type TTypeOfCreateTeaserModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'imageFileSizeExceeded'
	| 'videoFileSizeExceeded'
	| 'fileUploadError'
	| 'invalidFileFormat';
export interface ICreateTeaserTotalSchedule {
	id: string;
	value: string;
}

export interface ICreateTeaserState {
	visibleForm: TCreateTeaserVisibleForm;
	fileId: TFileId;
	sourceUrlLocally: TSourceUrlLocally;
	fetchedCustomers: IItemForGetShortInfo[];
	selectedCustomer: TCreateTeaserSelectedItem;
	fetchedRestaurants: IItemForGetShortInfo[];
	selectedRestaurants: string[];
	selectedContentType: TCreateTeaserSelectedContentType;
	description: string;
	schedule: string;
	totalSchedules: ICreateTeaserTotalSchedule[];
	selectedTransitionType: TCreateTeaserTransitionType;
	fetchedDishCategories: IItemForGetShortInfo[];
	selectedTransitionDishCategory: TCreateTeaserSelectedItem;
	fetchedDishSubCategories: IItemForGetShortInfo[];
	selectedTransitionDishSubCategory: TCreateTeaserSelectedItem;
	fetchedDishes: IItemForGetShortInfo[];
	selectedTransitionDishName: TCreateTeaserSelectedItem;
	fetchedGameCategories: IItemForGetShortInfo[];
	selectedTransitionGameCategory: TCreateTeaserSelectedItem;
	fetchedGames: IItemForGetShortInfo[];
	selectedTransitionGameName: TCreateTeaserSelectedItem;
	selectedControlPoint: TCreateTeaserControlPoint;
	delayTime: string;
	launchCount: string;
	countDown: string;
	dataForSubmit: ICreateTeaser | null;
	typeOfModalWindow: TTypeOfCreateTeaserModalWindow;
}

export const createTeaserInitialState: ICreateTeaserState = {
	visibleForm: 'mainForm',
	fileId: null,
	sourceUrlLocally: null,
	fetchedCustomers: [],
	selectedCustomer: null,
	fetchedRestaurants: [],
	selectedRestaurants: [],
	selectedContentType: null,
	description: '',
	schedule: '',
	totalSchedules: [],
	selectedTransitionType: null,
	fetchedDishCategories: [],
	selectedTransitionDishCategory: null,
	fetchedDishSubCategories: [],
	selectedTransitionDishSubCategory: null,
	fetchedDishes: [],
	selectedTransitionDishName: null,
	fetchedGameCategories: [],
	selectedTransitionGameCategory: null,
	fetchedGames: [],
	selectedTransitionGameName: null,
	selectedControlPoint: null,
	delayTime: '',
	launchCount: '',
	countDown: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateTeaserContext extends ICreateTeaserState {
	changeVisibleForm(value: TCreateTeaserVisibleForm): void;
	setFile(fileId: TFileId, sourceUrlLocally: TSourceUrlLocally): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setCustomer(value: TCreateTeaserSelectedItem): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setRestaurants(value: string[]): void;
	setContentType(value: TCreateTeaserSelectedContentType): void;
	changeDescription(value: string): void;
	changeSchedule(value: string): void;
	changeAdditionalSchedule(fieldId: string, value: string): void;
	setSchedules(value: ICreateTeaserTotalSchedule[]): void;
	setTransitionType(value: TCreateTeaserTransitionType): void;
	setFetchedDishCategories(value: IItemForGetShortInfo[]): void;
	setTransitionDishCategory(value: TCreateTeaserSelectedItem): void;
	setFetchedDishSubCategories(value: IItemForGetShortInfo[]): void;
	setTransitionDishSubCategory(value: TCreateTeaserSelectedItem): void;
	setFetchedDishes(value: IItemForGetShortInfo[]): void;
	setTransitionDishName(value: TCreateTeaserSelectedItem): void;
	setFetchedGameCategories(value: IItemForGetShortInfo[]): void;
	setTransitionGameCategory(value: TCreateTeaserSelectedItem): void;
	setFetchedGames(value: IItemForGetShortInfo[]): void;
	setTransitionGameName(value: TCreateTeaserSelectedItem): void;
	setControlPoint(value: TCreateTeaserControlPoint): void;
	changeDelayTime(value: string): void;
	changeLaunchCount(value: string): void;
	changeCountDown(value: string): void;
	setDataForSubmit(value: ICreateTeaser | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateTeaserModalWindow): void;
	resetFields(): void;
}

export const CreateTeaserContext = createContext<ICreateTeaserContext>({
	changeVisibleForm: () => undefined,
	setFile: () => undefined,
	setFetchedCustomers: () => undefined,
	setCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setRestaurants: () => undefined,
	setContentType: () => undefined,
	changeDescription: () => undefined,
	changeSchedule: () => undefined,
	changeAdditionalSchedule: () => undefined,
	setSchedules: () => undefined,
	setTransitionType: () => undefined,
	setFetchedDishCategories: () => undefined,
	setTransitionDishCategory: () => undefined,
	setFetchedDishSubCategories: () => undefined,
	setTransitionDishSubCategory: () => undefined,
	setFetchedDishes: () => undefined,
	setTransitionDishName: () => undefined,
	setFetchedGameCategories: () => undefined,
	setTransitionGameCategory: () => undefined,
	setFetchedGames: () => undefined,
	setTransitionGameName: () => undefined,
	setControlPoint: () => undefined,
	changeDelayTime: () => undefined,
	changeLaunchCount: () => undefined,
	changeCountDown: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createTeaserInitialState,
});
